import React, { useState, useEffect } from 'react';
import Card from '../components/Card';
import '@google/model-viewer';

import {
    LeftContainer,
    Title,
    Subtitle,
    RightContainer,
    Container,
    LoadingWrapper,
    ErrorP,
    ErrorWarp,
    ErrorImg,
    CardWrapper
} from '../style-comps/Listing.styles';
import { getListingsByUserId, getListingsWithChildren } from '../services/api';
import runningModel from '../Assets/models/running.glb';




const Listing = () => {
    const detectPlatform = (nickName = "") => {
        const name = nickName.toLowerCase();

        if (name.includes("bcom")) return "Booking.com";
        if (name.includes("google")) return "KozyGuru";
        if (name.includes("vrbo")) return "VRBO";
        if (name.includes("agoda")) return "Agoda";
        if (name.includes("expedia")) return "Expedia";

        return "Airbnb";
    };

    const formatUrl = (url) => {
        if (!url || url.trim() === "") return "#";
        if (url.startsWith("http://") || url.startsWith("https://")) return url;
        return `https://${url}`;
    };

    const toBool = (value) => {
        return value === true ||
            value === 1 ||
            value === "1" ||
            value === "true" ||
            value === "True";
    };



    const [properties, setProperties] = useState([]); // 儲存 Listings
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [progress, setProgress] = useState(0);

    const fetchListings = async () => {
        const token = localStorage.getItem('authToken');
        const userId = localStorage.getItem('userId');

        if (!token || !userId) {
            setError("Session expired. Please login again.");
            setLoading(false);
            return;
        }

        try {
            console.log("🌐 從 API 重新載入 Listings");
            const data = await getListingsWithChildren(userId);

            if (!data?.Listings || !Array.isArray(data.Listings)) {
                setError("Invalid data returned from API.");
                setLoading(false);
                return;
            }

            const formattedData = data.Listings.map(parent => {

                console.log("🟦 Listing parent raw:", parent.Id, {
                    IsPublishedToBookingEngine: parent.IsPublishedToBookingEngine,
                    isPublishedToBookingEngine: parent.isPublishedToBookingEngine,
                });

                // 平台有選、Online 有開，但 PlatformUrl 沒填時不能顯示 tag——
                // 否則點下去的連結會是 formatUrl("") = "#"，等於原地重開本頁。
                const parentChannels = (parent.IsListed === true && parent.IsActive === true && parent.Platform && parent.PlatformUrl?.trim())
                    ? [{ platform: parent.Platform, url: formatUrl(parent.PlatformUrl), online: true }]
                    : [];

                const childChannels = (parent.Children || [])
                    .filter(c => c.IsListed === true && c.IsActive === true && c.Platform && c.PlatformUrl?.trim())
                    .map(c => ({
                        platform: c.Platform,
                        url: formatUrl(c.PlatformUrl),
                        online: true
                    }));

                const isPublishedToBookingEngine = toBool(
                    parent.IsPublishedToBookingEngine ?? parent.isPublishedToBookingEngine
                );

                const parentListingId = parent.Id ?? parent.id;

                const kozyGuruChannel = isPublishedToBookingEngine
                    ? [{
                        platform: "KozyGuru",
                        url: `https://bookall.kozyguru.com/listing/${parentListingId}`,
                        online: true
                    }]
                    : [];

                const combinedChannels = [
                    ...kozyGuruChannel,
                    ...parentChannels,
                    ...childChannels,
                ];

                return {
                    listingId: parent.Id,
                    name: parent.Name || "N/A",
                    nickname: parent.NickName || "N/A",
                    kozyGuruName: parent.KozyGuruName || "",
                    city: parent.City || "N/A",
                    street: parent.Street || "N/A",
                    bedrooms: parent.Bedrooms || 0,
                    bathrooms: parent.Bathrooms || 0,
                    beds: parent.Beds || 0,
                    guests: parent.Guests || 0,
                    image: parent.Thumbnail || "",
                    status: parent.Status || "N/A",
                    isServicePms: parent.IsServicePms === true,
                    channels: combinedChannels
                };
            });
            const sortedData = [...formattedData].sort((a, b) => {
                if (a.isServicePms === b.isServicePms) return 0;
                return a.isServicePms ? -1 : 1;
            });

            setProperties(sortedData);
            localStorage.setItem('userListings', JSON.stringify(sortedData));

        } catch (err) {
            console.error("❌ 取得 Listings 失敗:", err);
            setError(err.message || "Failed to load listings.");
        } finally {
            setProgress(100);
            setTimeout(() => setLoading(false), 500);
        }
    };


    useEffect(() => {
        fetchListings();
    }, []);

    useEffect(() => {
        if (!loading) return;

        let percent = 0;
        const interval = setInterval(() => {
            percent += Math.floor(Math.random() * 10) + 5;
            percent = Math.min(percent, 100);
            setProgress(prev => (percent > prev ? percent : prev));

            if (percent >= 95) {
                clearInterval(interval);
            }
        }, 300);

        return () => clearInterval(interval);
    }, [loading]);





    if (loading) return (
        <LoadingWrapper>
            <p>KozyGuring... {progress}%</p>
            <model-viewer
                src={runningModel}
                autoplay
                animation-name="Run"
                camera-controls
            />
        </LoadingWrapper>
    );


    if (error) return (
        <ErrorWarp>
            <ErrorImg src='../Assets/mrK05.png'></ErrorImg>
            <ErrorP>Sorry , You Don't have any Property Listing </ErrorP>
        </ErrorWarp>);

    return (
        <Container>
            <LeftContainer>
                <Title>Properties</Title>
                <Subtitle>You can find your properties here.</Subtitle>
            </LeftContainer>


            <RightContainer>
                {Array.isArray(properties) && properties.length > 0 ? (
                    properties.map((property, index) => (
                        <CardWrapper key={index} $disabled={!property.isServicePms}>
                            <Card
                                name={property.name}
                                city={property.city}
                                street={property.street}
                                status={property.status}
                                bedrooms={property.bedrooms}
                                bathrooms={property.bathrooms}
                                beds={property.beds}
                                kozyGuruName={property.kozyGuruName}
                                guests={property.guests}
                                channels={property.channels}
                                image={property.image}
                                isServicePms={property.isServicePms}
                                buttonLabel="View Booking"
                                buttonLink={`/dashboard/calendar/${property.listingId}`}
                                listingId={property.listingId}
                                href={`/dashboard/calendar/${property.listingId}`}
                            />
                        </CardWrapper>
                    ))
                ) : (
                    <p>No listings found.</p>
                )}
            </RightContainer>
        </Container>
    );
};

export default Listing;